import { render } from "./download_direct.vue?vue&type=template&id=1b1c8ec2&scoped=true"
import script from "./download_direct.vue?vue&type=script&lang=js"
export * from "./download_direct.vue?vue&type=script&lang=js"

import "./download_direct.vue?vue&type=style&index=0&id=1b1c8ec2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1c8ec2"]])

export default __exports__